import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useLogin } from 'hooks/useLogin';
import { uiActions } from 'store/uiSlice';
import { isZendeskTokenValid } from 'utils/jwtUtils';
import { removeUserAuthData } from 'utils/login';
import AuthenticationLayout from 'views/SelfServe/SignUp/elements/AuthenticationLayout';

import { ZENDESK_DOMAIN } from 'components/LoginForm/constants';
import LoginModal from 'components/LoginModal/LoginModal';
import Typography from 'components/Typography/Typography';

import './style.scss';

const LoginPage = () => {
  const login = useLogin();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectTarget = urlParams.get('t')?.replace(' ', '+');
    const returnTo = urlParams.get('return_to');
    const brandId = urlParams.get('brand_id');
    const isZendeskLogoutUrl = urlParams.get('origin') === 'zendesk_logout';
    if (isZendeskLogoutUrl) {
      removeUserAuthData()
      window.location.href = `${window.location.origin}/login?brand_id=${brandId}&return_to=${returnTo}`;
    }
    if (login.isLoggedIn() && returnTo && brandId) {
      try {
        // Check if Zendesk token is still valid before redirecting
        if (isZendeskTokenValid()) {
          console.log('🔄 Valid Zendesk token, redirecting to:', decodeURIComponent(returnTo));
          window.location.href = decodeURIComponent(returnTo);
          return;
        } else {
          console.log('🧹 Invalid/expired Zendesk token, clearing auth data');
          removeUserAuthData();
          window.location.href = ZENDESK_DOMAIN;
          return;
        }
      } catch (error) {
        console.error('❌ Zendesk redirect failed, redirecting to dashboard:', error);
        navigate('/');
        return;
      }
    }


    if (login.isLoggedIn() && redirectTarget) {
      login.cleanUserLoginData();
      dispatch(uiActions.setTokenLoading(false));

      navigate(`./?t=${redirectTarget}`);
    }

    if (login.isLoggedIn()) {
      navigate(`/`);
    }
  }, [login, navigate, dispatch]);

  return login.isLoggedIn() ? null : (
    <AuthenticationLayout
      isLogin
      main={<LoginModal />}
      footer={
        <Typography className="text-p-s text-zinc-500 text-center">
          <div>
            Need help?{' '}
            <a
              href="mailto:support@appcharge-b2b.zendesk.com"
              className="underline font-bold"
            >
              Contact support
            </a>
          </div>
        </Typography>
      }
    />
  );
};

export default LoginPage;
